import React from 'react';
import styles from './StatisticsPage.module.css';

export const ChartSpinner = () => (
  <div className={styles.chartSpinner}>
    <div className={styles.spinner}>
      <svg viewBox="0 0 50 50" className={styles.spinnerSvg}>
        <circle
          className={styles.spinnerCircle}
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
        />
      </svg>
    </div>
  </div>
);